var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReserved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7251 7.29375C6.6626 7.2875 6.5876 7.2875 6.51885 7.29375C5.03135 7.24375 3.8501 6.025 3.8501 4.525C3.8501 2.99375 5.0876 1.75 6.6251 1.75C8.15635 1.75 9.4001 2.99375 9.4001 4.525C9.39385 6.025 8.2126 7.24375 6.7251 7.29375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2563 3C12.4688 3 13.4438 3.98125 13.4438 5.1875C13.4438 6.36875 12.5063 7.33125 11.3375 7.375C11.2875 7.36875 11.2313 7.36875 11.175 7.375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 9.24924C5.6875 8.31175 8.1437 8.4555 9.8562 9.59925C11.3687 10.6055 11.3687 12.2555 9.8562 13.268C8.13745 14.418 6.3125 14.5617 5.375 14.2492",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4624 13C12.9124 12.9062 13.3374 12.725 13.6874 12.4562C14.6624 11.725 14.6624 10.5187 13.6874 9.7875C13.3437 9.525 12.9249 9.35 12.4812 9.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37993 9.26387L1.9505 9.80241C1.62108 9.92559 1.35181 10.3152 1.35181 10.6646V12.793C1.35181 13.1311 1.57524 13.5751 1.84738 13.7785L3.07915 14.698C3.48306 15.0016 4.14764 15.0016 4.55155 14.698L5.78332 13.7785C6.05545 13.5751 6.27889 13.1311 6.27889 12.793V10.6646C6.27889 10.3123 6.00962 9.92272 5.68019 9.79954L4.25077 9.26387C4.00728 9.17507 3.61769 9.17507 3.37993 9.26387Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81242 12.2064C4.12883 12.2064 4.38534 11.9499 4.38534 11.6335C4.38534 11.3171 4.12883 11.0605 3.81242 11.0605C3.49601 11.0605 3.2395 11.3171 3.2395 11.6335C3.2395 11.9499 3.49601 12.2064 3.81242 12.2064Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8125 12.2051V13.0645",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserved);
export default __webpack_public_path__ + "static/media/reserved.e42bd454ae08f0bfc6f657a6abb0deca.svg";
export { ForwardRef as ReactComponent };